import * as React from "react";

import { CircleCheck, CircleX, X } from "lucide-react";

import { cn } from "@/lib/utils";

export interface ULThemeErrorProps extends React.ComponentProps<"div"> {
  variant?: "destructive" | "success";
  onDismiss?: () => void;
}

function ULThemeAlert({
  variant = "destructive",
  className,
  onDismiss,
  children,
  ...props
}: ULThemeErrorProps) {
  return (
    <div
      role="alert"
      className={cn(
        "lmn-ui-alert",
        variant === "destructive" && "lmn-ui-alert-error",
        variant === "success" && "lmn-ui-alert-success",
        className
      )}
      {...props}
    >
      <div className="lmn-ui-alert-left">
        <div className="lmn-ui-alert-icon-block" aria-hidden="true">
          {variant === "success" ? (
            <CircleCheck className="lmn-ui-alert-icon" />
          ) : (
            <CircleX className="lmn-ui-alert-icon" />
          )}
        </div>
        <div className="lmn-ui-alert-notification">{children}</div>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="lmn-ui-alert-close c-p"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

function ULThemeAlertTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div className={cn("lmn-ui-alert-title", className)} {...props} />;
}

export { ULThemeAlert, ULThemeAlertTitle };
export default ULThemeAlert;
